import React from 'react';
import PropTypes from 'prop-types';

// assets/js/entities/evaluations/diligence/Watchlists.jsx
import Watchlists from '../diligence/Watchlists';
import Fraud from '../diligence/Fraud/Fraud';
import Financial from '../diligence/Financial/Financial';
import IdentityQuestions from '../diligence/IdentityQuestions/IdentityQuestions';


const DiligenceDataPropTypes = {
  containsWatchlistMatch: PropTypes.bool.isRequired,
  hideFinancial: PropTypes.bool.isRequired,
  response: PropTypes.shape({
    diligence: PropTypes.shape({
      financial: PropTypes.shape({
        credit: PropTypes.arrayOf(PropTypes.object),
      }),
      identity_questions: PropTypes.arrayOf(PropTypes.object),
      fraud: PropTypes.shape({
        score: PropTypes.number,
        sources: PropTypes.objectOf(PropTypes.object),
      }),
      watchlists: PropTypes.object,
    }),
    financial: PropTypes.shape({
      credit: PropTypes.arrayOf(PropTypes.object),
    }),
  }).isRequired,
  evaluationToken: PropTypes.string.isRequired,
};


function DiligenceData({
  containsWatchlistMatch,
  hideFinancial,
  response,
  evaluationToken,
}) {
  return (
    <div className="diligence">
      {!containsWatchlistMatch && <Watchlists watchlists={response.diligence.watchlists || {}} />}
      <Fraud fraud={response.diligence.fraud || {}} evaluationToken={evaluationToken} />
      {!hideFinancial && (
        <Financial
          financial={{}.hasOwnProperty.call(response, 'financial')
            ? response.financial
            : response.diligence.financial}
        />
      )}
      <IdentityQuestions
        identityQuestions={response.diligence.identity_questions}
      />
    </div>
  );
}
DiligenceData.propTypes = DiligenceDataPropTypes;

export default DiligenceData;
